import { useCallback } from 'react'
import { HttpClientConfig, useHttpClientConfig } from '../../useHttpClientConfig'
import { useServiceCountryUrl } from '../useServiceCountryUrl'
import { makeCreateRecommendation } from './recommendations'
import { Recommendation, RecommendationCreateOneRequest } from '../../../types'

interface ProviderRecommendationService {
  createRecommendation: (request: RecommendationCreateOneRequest) => Promise<Recommendation>
  isReady: boolean
}

const useProviderRecommendationService = (): ProviderRecommendationService => {
  const { config } = useHttpClientConfig()
  const { url } = useServiceCountryUrl('providerRecommendation')
  const baseUrl = url.href

  const createRecommendation = useCallback(makeCreateRecommendation(baseUrl, config as HttpClientConfig), [baseUrl, config])

  return {
    createRecommendation,
    isReady: Boolean(config),
  }
}

export { useProviderRecommendationService }
